/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box, Grid } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import OverviewGlobalCard from './overviewGlobalCard.component';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
// import StatusStepperGlobal from './statusStepperGlobal.component';
import FinancialDetailsGlobalCard from './financialDetailsGlobalCard.component';
import AssignmentExtensionsCrudComponent from './assignmentExtensionsCrud.component';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';

import {
  getAssignmentTrip,
  getAssignmentTrips,
  upsertAssignmentTrip,
  deleteAssignmentTrip,
  getAssignmentExtensions,
  getGlobalInfo
} from 'modules/authorizations/store/actions/global.actions';
import { getAddress } from 'modules/authorizations/store/actions/authorizations.actions';
import {
  GET_ASSIGNMENT_TRIPS_FAILURE,
  UPSERT_ASSIGNMENT_TRIPS_FAILURE,
  DELETE_ASSIGNMENT_TRIPS_FAILURE,
  GET_ASSIGNMENT_EXTENSIONS_FAILURE,
  GET_GLOBAL_INFO_FAILURE
} from 'modules/authorizations/store/types/globalTypes';
import GlobalTripCard from './globalTripSummary.component';
import { showToast } from 'modules/layout/layout.actions';
import { SERVICE_IDS } from 'modules/enumerations/enumerationIds';
import CreateTripCard from 'modules/common/createAuthTripModal.component';
import AuthServiceGlobalEmailCardComponent from 'modules/emailTemplates/authEmailTemplates/authServiceGlobalEmailCard.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  }
});

const AssignmentLanding = props => {
  const {
    details,
    id,
    isReadOnly,
    location,
    enumerations,
    // globalStatus,
    emailTemplates,
    allVendorOptions,
    authCommentServiceTypes,
    authCommentRegardingTypes
  } = props;

  const globalInfo = details?.global?.globalInfo || [];
  const destinationData = Array.isArray(details?.global?.globalDestinationInfo) ? details.global.globalDestinationInfo : [];
  
  const globalId = details?.global?.globalInfo?.globalAssignmentId;
  const [currentTripId, setCurrentTripId] = useState(
    details?.global?.globalTrips && details?.global?.globalTrips[0] ? details?.global?.globalTrips[0].tripId : null
  );

  const createGlobalTemplate = () => {
    if (!emailTemplates || emailTemplates.length === 0) return [];
    const destTemplate = emailTemplates.filter(
      t => isIdEqual(t.serviceId, SERVICE_IDS.GLOBAL_SERVICE_ID) && t.containsGlobalDestination === true
    );
    const global = emailTemplates.filter(
      t => isIdEqual(t.serviceId, SERVICE_IDS.GLOBAL_SERVICE_ID) && t.containsGlobalDestination === false
    );
    const finalList = [...global];

    if (destTemplate.length > 0) {
      for (let i = 0; i < destTemplate.length; i++) {
        for (let j = 0; j < destinationData.length; j++) {
          const newTemp = { ...destTemplate[i], selectedSegmentServiceId: destinationData[j].globalDestinationServiceId, selectedVendorId: destinationData[j].destinationServiceCompanyId };
          finalList.push(newTemp);
        }
      }
    }

    return finalList;
  };

  const globalTemplate = createGlobalTemplate();

  // TODO: Add max number of trips as enum in the DB once business input is received on which options are allowed.
  const maxNumTrips = [
    { title: '', id: '00000000-0000-0000-0000-000000000000' },
    { title: 'One Trip', id: '8f72b0b5-5722-471f-ae69-0ad9fe685ca8' },
    { title: 'Two Trips', id: '71f4770a-b489-4e6a-af1c-ca86370cad10' },
    { title: 'Three Trips', id: '6553b8d0-0c3c-4463-8fa3-02d8bcca3488' }
  ];

  const createAddressName = address => {
    const addressParts = [address.addressLineOne, address.city, address.state].filter(Boolean);
    return addressParts.length > 0 ? addressParts.join(', ') : '';
  };

  let addressOptions = Array.isArray(details?.addresses)
    ? details?.addresses
      .map(s => ({
        id: s.addressId,
        title: createAddressName(s),
        ...s
      }))
      .filter(option => option.title)
    : [];

  const vendorOptions = React.useMemo(() => {
    const global = details?.global;
    const destVendorIds = (global?.globalDestinationInfo || []).map(s => s.destinationServiceCompanyId).filter(Boolean);
    const langVendorIds = (global?.globalLanguageTrainingInfo || []).map(s => s.languageTrainingVendorId).filter(Boolean);
    const intlVendorIds = (global?.globalIntlSchoolingInfo || []).map(s => s.schoolingVendorId).filter(Boolean);

    const vendorIdSet = new Set([...destVendorIds, ...langVendorIds, ...intlVendorIds]);
    const options = Array.from(vendorIdSet)
      .map(vendorId => {
        const v = (allVendorOptions || []).find(x => x.vendorId === vendorId);
        if (!v?.officeEmail || !v?.companyName) return null;

        return {
          vendorId: vendorId,
          officeEmail: v.officeEmail,
          companyName: v.companyName
        };
      })
      .filter(Boolean);

    return options;
  }, [details, allVendorOptions]);

  const trip = details?.global?.globalTrips ? details?.global?.globalTrips.find(s => s.tripId === currentTripId) : null;

  const createTrip = async values => {
    const authId = details?.authorizationDetails?.fileId;
    const serviceId = details?.global.globalInfo.globalAssignmentId;
    let newValues = {};

    newValues.tripName = values.tripName ? values.tripName : '';
    newValues.tripCategoryId = '644f419f-072d-49ad-a86c-58052b45175c';
    newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    newValues.typeOfTrip = values.typeOfTrip ? values.typeOfTrip : '';
    newValues.tripStartDate = values.tripStartDate ? values.tripStartDate : new Date();
    newValues.tripEndDate = values.tripEndDate ? values.tripEndDate : new Date();
    newValues.departureDate = values.departureDate ? values.departureDate : new Date();
    newValues.arrivalDate = values.arrivalDate ? values.arrivalDate : new Date();
    newValues.tripDuration = values.tripDuration ? values.tripDuration : 0;
    newValues.departureAddressId = values.departureAddressId ? values.departureAddressId : 0;
    newValues.destinationAddressId = values.destinationAddressId ? values.destinationAddressId : 0;
    newValues.specialNeeds = values.specialNeeds ? values.specialNeeds : '';
    newValues.notes = values.notes ? values.notes : '';

    if (values.hasBookingDetails && values.hasBookingDetails === 'Self Booked') {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = values.otherRentalCar;
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;
    newValues.addedBy = values.addedBy ? values.addedBy : 0;
    newValues.addedOn = values.addedOn ? values.addedOn : new Date();
    newValues.modifiedBy = 0;
    newValues.modifiedOn = new Date();

    const resp = await props.upsertAssignmentTrip(serviceId, newValues);

    if (resp.type === UPSERT_ASSIGNMENT_TRIPS_FAILURE) {
      props.showToast('Failed to update the global trips info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      const globalInfoResp = await props.getGlobalInfo(authId);
      if (globalInfoResp.type === GET_GLOBAL_INFO_FAILURE) {
        props.showToast('Failed to fetch global trips, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        props.showToast('New global Trip created successfully.', { userMustDismiss: false, severity: 'success' });
        setCurrentTripId(globalInfoResp.response.globalTrips[globalInfoResp.response.globalTrips.length - 1].tripId);
      }
    }
  };

  const deleteTrip = async () => {
    const deleteTripResp = await props.deleteAssignmentTrip(currentTripId);
    if (deleteTripResp.type === DELETE_ASSIGNMENT_TRIPS_FAILURE) {
      props.showToast('Failed to delete the current global trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      props.showToast('Trip deleted successfully.', { userMustDismiss: false, severity: 'success' });
      setCurrentTripId(details?.authDetails?.trips.filter(t => t.tripCategory === 'Homefinding')[0].tripId);
      const globalInfoResp = await props.getGlobalInfo(id);
      if (globalInfoResp.type === GET_GLOBAL_INFO_FAILURE) {
        props.showToast('Failed to get the global trips info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }
  };

  const getTripData = async () => {
    const tripResp = await props.getAssignmentTrips(currentTripId);
    if (tripResp.type === GET_ASSIGNMENT_TRIPS_FAILURE) {
      props.showToast('Failed to get the global trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  };

  const getGlobalAssignmentDetails = async () => {
    const globalExtensions = await props.getAssignmentExtensions(globalInfo?.globalAssignmentId || 0);
    if (globalExtensions.type === GET_ASSIGNMENT_EXTENSIONS_FAILURE) {
      props.showToast('Failed to get the global extensions info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }
  };

  useEffect(() => {
    if (details && details?.global?.globalInfo && details?.global?.globalExtensions.length <= 0) {
      getGlobalAssignmentDetails();
    }
    if (currentTripId) {
      getTripData();
    }
  }, [currentTripId]);

  return (
    <Box>
      {/* <StatusStepperGlobal
        status={globalStatus}
        globalExtensions={details?.global?.globalExtensions}
        globalInfo={details?.global?.globalInfo}
      /> */}
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} xl={8} rowSpacing={2}>
          <OverviewGlobalCard globalInfo={globalInfo} id={id} isReadOnly={isReadOnly} enumerations={enumerations} />
          <Box sx={{ paddingTop: '16px' }}>
            <AssignmentExtensionsCrudComponent
              globalExtensions={details?.global?.globalExtensions}
              assignmentId={details?.global?.globalInfo?.globalAssignmentId}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              authId={id}
            />
          </Box>
          <Box sx={{ paddingTop: '16px' }}>
            <Grid item sx={{ marginBottom: '10px' }}>
              <CreateTripCard
                onSubmit={createTrip}
                onDelete={deleteTrip}
                familyMembers={details?.familyMembers}
                trips={details?.global?.globalTrips}
                location={location}
                enumerations={props.enumerations}
                addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                showToast={showToast}
                classes={props.classes}
                currentTripId={currentTripId}
                setCurrentTripId={setCurrentTripId}
                defaultCategory={'644f419f-072d-49ad-a86c-58052b45175c'}
                isReadOnly={location.pathname.includes('expenses') || isReadOnly}
                maxNumTrips={maxNumTrips.find(option => option.id === details?.global?.globalInfo?.maxNumberOfTrips)?.title}
                tripCapAmount={details?.global?.globalInfo?.tripCapAmount}
              />
            </Grid>
            {currentTripId && (
              <>
                <Grid item>
                  <GlobalTripCard
                    trip={trip}
                    familyMembers={details?.familyMembers}
                    travelRequests={details?.global?.globalTrips}
                    hideEdit={location.pathname.includes('expenses') || isReadOnly}
                    id={id}
                    addresses={addressOptions.filter(s => s.excludeAddressFromSelection === false)}
                    enumerations={enumerations}
                    serviceId={details?.global?.globalInfo?.globalAssignmentId}
                  />
                </Grid>
              </>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} xl={4} rowSpacing={2}>
          <AuthServiceGlobalEmailCardComponent
            authId={id}
            communication={details.authorizationDetails}
            serviceTemplates={globalTemplate}
            serviceId={SERVICE_IDS.GLOBAL_SERVICE_ID}
            authCommentServicesEnum={authCommentServiceTypes}
            authCommentRegardingEnum={authCommentRegardingTypes}
            authSentTemplates={details.sentEmailTemplates}
            history={props.history}
            selectedAuthServiceId={globalId}
            vendorOptions={vendorOptions}
            allVendorOptions={allVendorOptions}
            selectedSegmentServiceId={globalId}
            emailTemplates={emailTemplates}
            isReadOnly={isReadOnly}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '16px' }}>
            <FinancialDetailsGlobalCard globalInfo={globalInfo} id={id} isReadOnly={isReadOnly} enumerations={enumerations} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

AssignmentLanding.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAssignmentTrips,
    getAssignmentTrip,
    upsertAssignmentTrip,
    deleteAssignmentTrip,
    getAssignmentExtensions,
    getAddress,
    showToast,
    getGlobalInfo
  })
)(AssignmentLanding);
